
import { defineComponent } from 'vue'
import { Card, PrimaryButton, Form } from '@design-system/ui'
import Link from '../components/Link.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faShop, faFileInvoiceDollar, faSackDollar, faQuestionCircle, faSearch } from '@fortawesome/free-solid-svg-icons'
import api from '@/services/api'
import SessionService from '../SessionService'
import { differenceInMonths, startOfMonth, format } from 'date-fns'
import CustomInput from '../components/input/Input.vue'
import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'

export default defineComponent({
  name: 'Estabelecimentos',
  components: {
    Card,
    FontAwesomeIcon,
    Link,
    CustomInput,
    PrimaryButton,
    Form
  },
  data () {
    return {
      loadingEstabelecimentosAmount: true,
      search: null,
      showInfo:
      {
        '1a': false,
        '1b': false,
        '1c': false
      },
      month: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro'
      ],
      requestErrors: {
        estabelecimentosAmount: false,
        transactionSeries: false,
        comissionSeries: false,
        averageSeries: false,
        totalSeries: false,
        estabelecimentoSeries: false,
        softwareHouseBalanceSeries: false
      },
      buttonIcons: {
        search: {
          icon: faSearch
        }
      },
      estabelecimentos: 0,
      shop: faShop,
      fileDollar: faFileInvoiceDollar,
      faQuestionCircle: faQuestionCircle,
      sackDollar: faSackDollar,
      loadingTotalTransactions: true,
      loadingTotalTransactionsValue: true,
      totalTransactions: 0,
      totalTransactionsValue: 0,
      totalCompanyTransactionsValue: 0,
      totalSoftwareHouseBalance: 0,
      startFilter: startOfMonth(new Date()),
      endFilter: new Date(),
      filterDateStartErrorMessage: '',
      filterDateEndErrorMessage: ''
    }
  },
  mounted () {
    tippy(this.$refs.tooltip)
    tippy(this.$refs.tooltip2)
    tippy(this.$refs.tooltip3)
  },
  created () {
    const session = new SessionService()
    this.SOFTWARE_HOUSE_CNPJ = session.cnpj()
    this.getData()
  },
  methods: {
    async getData () {
      const rangeValidated = this.validateDateRange(this.startFilter, this.endFilter)
      if (!rangeValidated) return

      this.setLoading()

      const queries = {
        start: format(this.startFilter, 'yyyy-MM-dd'),
        end: format(this.endFilter, 'yyyy-MM-dd')
      }

      api.get(`relatorios/transactions/${this.SOFTWARE_HOUSE_CNPJ}/amount`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        params: queries
      })
        .then(response => {
          this.totalTransactions = response.data.amount
          this.loadingTotalTransactions = false
        })
        .catch(() => {
          this.requestErrors.transactionSeries = true
        })

      api.get(`relatorios/total-transactions/${this.SOFTWARE_HOUSE_CNPJ}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        params: queries
      })
        .then(response => {
          this.totalTransactionsValue = response.data.totalTransactionsValue
          this.totalCompanyTransactionsValue = response.data.totalCompanyTransactionsValue
          this.totalSoftwareHouseBalance = response.data.totalSoftwareHouseBalance
          this.loadingTotalTransactionsValue = false
        })
        .catch(() => {
          this.requestErrors.totalSeries = true
          this.requestErrors.softwareHouseBalanceSeries = true
        })

      api.get(`relatorios/software-houses/${this.SOFTWARE_HOUSE_CNPJ}/companies/active`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })
        .then(response => {
          this.estabelecimentos = response.data.total

          this.loadingEstabelecimentosAmount = false
        })
        .catch(() => {
          this.requestErrors.estabelecimentosAmount = true
        })
    },
    handleEstabelecimentos () {
      this.$router.push('/estabelecimentos')
    },

    handleVolumetria () {
      this.$router.push('/volumetria')
    },

    changeFilterDate (index, value) {
      const fieldName = index.target?.name || index
      this[fieldName] = value

      if (fieldName === 'startFilter') {
        this.filterDateStartErrorMessage = ''
      } else if (fieldName === 'endFilter') {
        this.filterDateEndErrorMessage = ''
      }
    },

    validateDateRange (startDate: Date, endDate: Date) {
      const intervalInMonths = differenceInMonths(endDate, startDate)
      const maxInterval = 12

      if (!startDate) {
        this.filterDateStartErrorMessage = 'Data não informada'
      }

      if (!endDate) {
        this.filterDateEndErrorMessage = 'Data não informada'
      }

      if (startDate > endDate) {
        this.filterDateStartErrorMessage = 'Data inicial maior que a data final'
        this.filterDateEndErrorMessage = 'Data final menor que a data inicial'
      }

      if (endDate > new Date()) {
        this.filterDateEndErrorMessage = 'Não é possível buscar dados futuros'
      }

      if (intervalInMonths > maxInterval) {
        this.filterDateStartErrorMessage = 'Intervalo de datas maior que 12 meses'
        this.filterDateEndErrorMessage = 'Intervalo de datas maior que 12 meses'
      }

      if (this.filterDateStartErrorMessage || this.filterDateEndErrorMessage) {
        return false
      }

      this.filterDateStartErrorMessage = ''
      this.filterDateEndErrorMessage = ''
      return true
    },

    setLoading () {
      this.loadingEstabelecimentosAmount = true
      this.loadingTotalTransactions = true
      this.loadingTotalTransactionsValue = true
    }
  },
  beforeMount () {
    this.$store.commit('changeActiveMenu', 0)
  }
})
